import React, { useContext } from 'react'
import classNames from 'classnames'
import { I18nextContext } from '@toasttab/shared/src/context/i18nextContext'
import { localizeLink } from '@toasttab/shared/src/utils/linkUtils'
import { SubMenuItemProps } from './ContentfulNavigation.d'

const SubMenuItem = ({
  entryType,
  heapClass,
  title,
  url
}: SubMenuItemProps) => {
  const localizationContext = useContext(I18nextContext)

  const isArticle = entryType === 'articles'
  const listItemCss = classNames({
    'font-effra text-[15px] mb-8 lg:mb-3 group leading-none': !isArticle,
    'font-sansPro text-[12px]': isArticle
  })

  return (
    <li className={listItemCss} data-testid='SubMenuItem' role='none'>
      {isArticle ? (
        <span
          className={`${heapClass} inline-block font-normal text-secondary w-full`}
          role='menuitem'
        >
          {title}
        </span>
      ) : (
        <a
          className={`${heapClass} font-normal text-default group-hover:text-blue-75 group-focus:text-blue-75 group-hover:font-semibold group-focus:font-semibold`}
          role='menuitem'
          href={localizeLink(
            url,
            localizationContext.language,
            localizationContext
          )}
        >
          {title}
          <span className='inline-flex invisible absolute mt-[-6px] ml-1 content-icon-right-arrow-blue h-6 w-6 group-hover:visible group-focus:visible' />
        </a>
      )}
    </li>
  )
}

export default SubMenuItem
